import React from 'react';
import classNames from 'classnames';

const Main = ({ className, children, style, styles }) => (
  <div className={classNames('main', className)} style={{ ...style, ...styles }}>
    {children}
  </div>
);

export default Main;
